/**
 * Функция ищет 2 значения, ближайшую меньшую и большую к target намотку
 * если возвращает 0, значит уменьшение или увеличение невозможно
 *
 * @param copies кол-во копий
 * @param cols ручьи
 * @param target целевая намотка
 * @returns
 */
export function generateListOfWindings(
    copies: number,
    cols: number,
    target: number // Например 700
) {
    const idealRolls = copies / target

    const floorRolls = Math.floor(idealRolls)
    const ceilRolls = Math.ceil(idealRolls)

    const toMultiple = (value: number, direction: 'down' | 'up') => {
        if (direction === 'down') {
            return Math.floor(value / cols) * cols
        } else {
            return Math.ceil(value / cols) * cols
        }
    }

    const lowerRolls = toMultiple(floorRolls, 'down')
    const upperRolls = toMultiple(ceilRolls, 'up')

    const lowerTarget = upperRolls > 0 ? copies / upperRolls : 0
    const upperTarget = lowerRolls > 0 ? copies / lowerRolls : 0

    return [lowerTarget, upperTarget]
}

/**
 * Функция ищет 2 значения, ближайшее меньшее и больше к target кол-во копий
 *
 * @param winding намотка
 * @param cols ручьи
 * @param target целевое кол-во копий
 * @returns
 */
export function generateListOfCopies(
    winding: number,
    cols: number,
    target: number // Например 12000
) {
    // if(!winding || !cols) {
    //     return [0, 0]
    // }
    const baseCopies = winding * cols

    const idealSteps = target / baseCopies
    const baseSteps = Math.ceil(idealSteps)

    const lowerSteps = Math.max(baseSteps - 1, 1)

    return [lowerSteps * baseCopies, baseSteps * baseCopies].sort((a, b) => a - b)
}
